import { motion } from "framer-motion";
import { MessageSquare, Calculator, CheckCircle2, Download } from "lucide-react";
import { STEPS } from "@/data/site";

const ICONS = [MessageSquare, Calculator, CheckCircle2, Download];

export default function HowItWorks() {
  return (
    <section
      data-testid="how-section"
      className="relative py-24 md:py-32 border-t border-slate-100 bg-[#fafafa]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="mb-16 md:mb-20 grid grid-cols-1 md:grid-cols-12 gap-8 items-end">
          <div className="md:col-span-6">
            <div className="text-xs uppercase tracking-[0.24em] text-blue-600 font-semibold">/ Process</div>
            <h2 className="mt-4 font-display text-4xl md:text-6xl font-light tracking-tight text-slate-900 leading-[1.02]">
              From requirement<br />to delivery,{" "}
              <span className="font-serif-editorial italic">in four moves</span>.
            </h2>
          </div>
          <div className="md:col-span-4 md:col-start-9 text-base md:text-lg text-slate-600 leading-relaxed">
            No forms in triplicate, no month-long RFPs. A working, WhatsApp-friendly cadence.
          </div>
        </div>

        <div className="relative">
          <div className="hidden md:block absolute top-[54px] left-[10%] right-[10%] h-px bg-slate-200" />
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-4">
            {STEPS.map((s, i) => {
              const Icon = ICONS[i];
              return (
                <motion.div
                  key={s.n}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-80px" }}
                  transition={{ delay: i * 0.1, duration: 0.8 }}
                  className="relative flex flex-col items-start"
                  data-testid={`step-${s.n}`}
                >
                  <div className="relative z-10 w-24 h-24 rounded-3xl bg-white border border-slate-200 flex items-center justify-center shadow-sm">
                    <Icon className="w-8 h-8 text-slate-900" strokeWidth={1.35} />
                    <div className="absolute -top-2 -right-2 w-7 h-7 rounded-full bg-blue-600 text-white text-[11px] font-medium flex items-center justify-center">
                      {s.n}
                    </div>
                  </div>
                  <h3 className="mt-6 font-display text-2xl font-medium tracking-tight text-slate-900">
                    {s.title}
                  </h3>
                  <p className="mt-3 text-sm text-slate-500 leading-relaxed max-w-[280px]">{s.body}</p>
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
